// classNames
import classNames from 'classnames';

// styles
import css from './Priorities.module.scss';

// framer-motion
import { motion } from 'framer-motion';

// components
import Image from 'next/image';
import T from '../../../common/components/T';
import { navigateV2 } from '../../../common/utils/router';

export const getTitleComponent = (index) => {
    switch (index) {
        case '0': {
            return (
                <>
                    <div className={css.textBlock}>
                        <motion.h2 className={css.carouselTitle}>
                            <T textName={'landing-carouselpage-new1'} defaultStr={'Наука долголетия'} page='/' />
                        </motion.h2>
                    </div>
                    <div className={css.textBlock}>
                        <motion.h2 className={css.carouselTitle}>
                            <T textName={'landing-carouselpage-new2'} defaultStr={'в каждой молекуле'} page='/' />
                        </motion.h2>
                    </div>
                </>
            );
        }
        case '1': {
            return (
                <>
                    <div className={css.textBlock}>
                        <motion.h2 className={css.carouselTitle}>
                            <T textName={'landing-carouselpage-new11'} defaultStr={'Наша'} page='/' />
                        </motion.h2>
                    </div>
                    <div className={classNames(css.textBlock, css.textBlock_Lg)}>
                        <motion.h2 className={classNames(css.carouselTitle, css.carouselTitle_Lg)}>
                            <T textName={'landing-carouselpage-new12'} defaultStr={'Миссия'} page='/' />
                        </motion.h2>
                    </div>
                </>
            );
        }
        case '2': {
            return (
                <>
                    <div className={css.textBlock}>
                        <motion.h2 className={css.carouselTitle}>
                            <T textName={'landing-carouselpage-new16'} defaultStr={'Стань частью'} page='/' />
                        </motion.h2>
                    </div>
                    <div className={css.textBlock}>
                        <motion.h2 className={css.carouselTitle} style={{ paddingBottom: 0 }}>
                            <T textName={'landing-main_globaltrend_text'} defaultStr={'Global Trend'} page='/' />
                        </motion.h2>
                    </div>
                </>
            );
        }
        default:
            return null;
    }
};

export const getDescriptionComponent = (index, desctopLg, isUserToken) => {
    switch (index) {
        case '0': {
            return (
                <>
                    <div className={css.descriptionWrapper__item}>
                        <div className={css.iconsBlockWrapper}>
                            <motion.div className={css.iconsWrapper}>
                                <Image
                                    width={72}
                                    height={72}
                                    src={'/src/landing/carousel/icon1.svg'}
                                    alt={'first-icon3-png'}
                                    className={css.iconsWrapperIcon}
                                />
                            </motion.div>
                        </div>
                        {desctopLg ? (
                            <div>
                                <div className={css.descriptionBlock}>
                                    <motion.p className={css.descriptionText}>
                                        <T
                                            textName={'landing-carouselpage-new3'}
                                            defaultStr={'Уникальные формулы разрабатываются ведущими'}
                                            page='/'
                                        />
                                    </motion.p>
                                </div>
                                <div className={css.descriptionBlock}>
                                    <motion.p className={css.descriptionText}>
                                        <T
                                            textName={'landing-carouselpage-new4'}
                                            defaultStr={'ученными нутрициологии, космецефтики и'}
                                            page='/'
                                        />
                                    </motion.p>
                                </div>
                                <div className={css.descriptionBlock}>
                                    <motion.p className={css.descriptionText}>
                                        <T
                                            textName={'landing-carouselpage-new5'}
                                            defaultStr={'экспертами Anti-Age индустрии.'}
                                            page='/'
                                        />
                                    </motion.p>
                                </div>
                            </div>
                        ) : (
                            <div>
                                <div className={css.descriptionBlock}>
                                    <motion.p className={css.descriptionText}>
                                        <T
                                            textName={'landing-carouselpage-new3_common'}
                                            defaultStr={
                                                'Уникальные формулы разрабатываются ведущими ученными нутрициологии, космецефтики и экспертами Anti-Age индустрии.'
                                            }
                                            page='/'
                                        />
                                    </motion.p>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className={css.descriptionWrapper__item}>
                        <div className={css.iconsBlockWrapper}>
                            <motion.div className={css.iconsWrapper}>
                                <Image
                                    width={72}
                                    height={72}
                                    src={'/src/landing/carousel/icon2.svg'}
                                    alt={'first-icon3-png'}
                                    className={css.iconsWrapperIcon}
                                />
                            </motion.div>
                        </div>
                        {desctopLg ? (
                            <div className={css.descriptionBlockWraper_Slide01}>
                                <div className={css.descriptionBlock}>
                                    <motion.p className={css.descriptionText}>
                                        <T
                                            textName={'landing-carouselpage-new6'}
                                            defaultStr={'Мы используем самые передовые технологии и'}
                                            page='/'
                                        />
                                    </motion.p>
                                </div>
                                <div className={css.descriptionBlock}>
                                    <motion.p className={css.descriptionText}>
                                        <T
                                            textName={'landing-carouselpage-new7'}
                                            defaultStr={'натуральные ингредиенты, чтобы создать продукты'}
                                            page='/'
                                        />
                                    </motion.p>
                                </div>
                                <div className={css.descriptionBlock}>
                                    <motion.p className={css.descriptionText}>
                                        <T
                                            textName={'landing-carouselpage-new8'}
                                            defaultStr={'способные продлить активное долголетие,'}
                                            page='/'
                                        />
                                    </motion.p>
                                </div>
                                <div className={css.descriptionBlock}>
                                    <motion.p className={css.descriptionText}>
                                        <T
                                            textName={'landing-carouselpage-new9'}
                                            defaultStr={'запустить скрытые ресурсы организма, укрепить'}
                                            page='/'
                                        />
                                    </motion.p>
                                </div>
                                <div className={css.descriptionBlock}>
                                    <motion.p className={css.descriptionText}>
                                        <T
                                            textName={'landing-carouselpage-new10'}
                                            defaultStr={'здоровье и раскрыть истинную красоту изнутри!'}
                                            page='/'
                                        />
                                    </motion.p>
                                </div>
                            </div>
                        ) : (
                            <div className={css.descriptionBlockWraper_Slide01}>
                                <div className={css.descriptionBlock}>
                                    <motion.p className={css.descriptionText}>
                                        <T
                                            textName={'landing-carouselpage-new6_common'}
                                            defaultStr={
                                                'Мы используем самые передовые технологии и натуральные ингредиенты, чтобы создать продукты способные продлить активное долголетие, запустить скрытые ресурсы организма, укрепить здоровье и раскрыть истинную красоту изнутри!'
                                            }
                                            page='/'
                                        />
                                    </motion.p>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            );
        }
        case '1': {
            return (
                <div>
                    <div className={css.descriptionBlock}>
                        <motion.p className={classNames(css.descriptionText, css.descriptionText_Lg)}>
                            <T
                                textName={'landing-carouselpage-new13'}
                                defaultStr={'Мы создаем успешное сообщество здоровых,'}
                                page='/'
                            />
                        </motion.p>
                    </div>
                    <div className={css.descriptionBlock}>
                        <motion.p className={classNames(css.descriptionText, css.descriptionText_Lg)}>
                            <T
                                textName={'landing-carouselpage-new14'}
                                defaultStr={'счастливых и щедрых людей, меняющих мир'}
                                page='/'
                            />
                        </motion.p>
                    </div>
                    <div className={css.descriptionBlock}>
                        <motion.p className={css.descriptionText}>
                            <T textName={'landing-carouselpage-new15'} defaultStr={'к лучшему!'} page='/' />
                        </motion.p>
                    </div>
                </div>
            );
        }
        case '2': {
            return (
                <>
                    <div className={css.descriptionWrapper__item}>
                        <div className={css.iconsBlockWrapper}>
                            <motion.div className={css.iconsWrapper}>
                                <Image
                                    width={72}
                                    height={72}
                                    src={'/src/landing/carousel/icon3.svg'}
                                    alt={'first-icon3-png'}
                                    className={css.iconsWrapperIcon}
                                />
                            </motion.div>
                        </div>
                        {desctopLg ? (
                            <div>
                                <div className={css.descriptionBlock}>
                                    <motion.p className={css.descriptionText}>
                                        <T
                                            textName={'landing-carouselpage-new18'}
                                            defaultStr={'Global Trend - это не только качественные продукты,'}
                                            page='/'
                                        />
                                    </motion.p>
                                </div>
                                <div className={css.descriptionBlock}>
                                    <motion.p className={css.descriptionText}>
                                        <T
                                            textName={'landing-carouselpage-new19'}
                                            defaultStr={'это сообщество успешных единомышленников,'}
                                            page='/'
                                        />
                                    </motion.p>
                                </div>
                                <div className={css.descriptionBlock}>
                                    <motion.p className={css.descriptionText}>
                                        <T
                                            textName={'landing-carouselpage-new20'}
                                            defaultStr={'стремящихся стать лучшей версией себя, которые'}
                                            page='/'
                                        />
                                    </motion.p>
                                </div>
                                <div className={css.descriptionBlock}>
                                    <motion.p className={css.descriptionText}>
                                        <T
                                            textName={'landing-carouselpage-new21'}
                                            defaultStr={'задают тренды меняющие мир к лучшему!'}
                                            page='/'
                                        />
                                    </motion.p>
                                </div>
                            </div>
                        ) : (
                            <div>
                                <div className={css.descriptionBlock}>
                                    <motion.p className={css.descriptionText}>
                                        <T
                                            textName={'landing-carouselpage-new18_common'}
                                            defaultStr={
                                                'Global Trend - это не только качественные продукты, это сообщество успешных единомышленников, стремящихся стать лучшей версией себя, которые задают тренды меняющие мир к лучшему!'
                                            }
                                            page='/'
                                        />
                                    </motion.p>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className={css.descriptionWrapper__item}>
                        <div className={css.iconsBlockWrapper}>
                            <motion.div className={css.iconsWrapper}>
                                <Image
                                    width={72}
                                    height={72}
                                    src={'/src/landing/carousel/icon4.svg'}
                                    alt={'first-icon4'}
                                    className={css.iconsWrapperIcon}
                                />
                            </motion.div>
                        </div>
                        {desctopLg ? (
                            <div>
                                <div className={css.descriptionBlock}>
                                    <motion.p className={css.descriptionText}>
                                        <T
                                            textName={'landing-carouselpage-new22'}
                                            defaultStr={'Став частью команды ты сможешь раскрыть свой'}
                                            page='/'
                                        />
                                    </motion.p>
                                </div>
                                <div className={css.descriptionBlock}>
                                    <motion.p className={css.descriptionText}>
                                        <T
                                            textName={'landing-carouselpage-new23'}
                                            defaultStr={'лидерский и творческий потенциал, получить'}
                                            page='/'
                                        />
                                    </motion.p>
                                </div>
                                <div className={css.descriptionBlock}>
                                    <motion.p
                                        initial={{ y: '120%' }}
                                        animate={{ y: 0 }}
                                        transition={{ delay: 0.5, duration: 0.3, ease: 'linear' }}
                                        className={css.descriptionText}
                                    >
                                        <T
                                            textName={'landing-carouselpage-new24'}
                                            defaultStr={'признание, финансовый достаток, расширить границы'}
                                            page='/'
                                        />
                                    </motion.p>
                                </div>
                                <div className={css.descriptionBlock}>
                                    <motion.p className={css.descriptionText}>
                                        <T textName={'landing-carouselpage-new25'} defaultStr={'своих возможностей.'} page='/' />
                                    </motion.p>
                                </div>
                                <div className={css.buttonBlock}>
                                    <motion.p
                                        className={css.carouselButton}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (isUserToken) {
                                                navigateV2('/office');
                                            } else {
                                                navigateV2('/auth/register');
                                            }
                                        }}
                                        onContextMenu={(e) => {
                                            e.preventDefault();
                                            if (isUserToken) {
                                                window.open('/office', '_blank');
                                            } else {
                                                window.open('/auth/register', '_blank');
                                            }
                                        }}
                                    >
                                        <T textName={'landing-carouselpage-new26'} defaultStr={'Стать партнером'} page='/' />
                                    </motion.p>
                                </div>
                            </div>
                        ) : (
                            <div>
                                <div className={css.descriptionBlock}>
                                    <motion.p className={css.descriptionText}>
                                        <T
                                            textName={'landing-carouselpage-new22_common'}
                                            defaultStr={
                                                'Став частью команды ты сможешь раскрыть свой лидерский и творческий потенциал, получить признание, финансовый достаток, расширить границы своих возможностей.'
                                            }
                                            page='/'
                                        />
                                    </motion.p>
                                </div>
                                <div className={css.buttonBlock}>
                                    <motion.p
                                        className={css.carouselButton}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (isUserToken) {
                                                navigateV2('/office');
                                            } else {
                                                navigateV2('/auth/register');
                                            }
                                        }}
                                    >
                                        <T textName={'landing-carouselpage-new26'} defaultStr={'Стать партнером'} page='/' />
                                    </motion.p>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            );
        }
    }
};
